import { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { InvoiceResponseViewModel } from 'types/invoice';
import { AppointmentDetailsRow } from './AppointmentDetailsRow';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import numberWithCommas from 'utils/numberWithCommas';
import { parametrizeURL } from 'routes/utils';
import { PATH } from 'routes/path';
import Divider from '@mui/material/Divider';
import { BackdropLoader } from 'components/@shared/Loaders';

interface Props {
    appointmentId: string;
    invoice: InvoiceResponseViewModel;
    showActions: boolean;
}

const invoiceStyles = {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'primary.light',
    borderRadius: '4px',
    gap: 2,
    p: 2,
};

export const AppointmentInvoice = ({ appointmentId, invoice, showActions }: Props) => {
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    const createInvoiceHandler = useCallback(() => {
        navigate(parametrizeURL(PATH.CREATE_INVOICE, { appointmentId }));
    }, [navigate]);

    if (invoice) {
        return (
            <Box>
                {isLoading && <BackdropLoader />}
                <Stack sx={invoiceStyles}>
                    <Box key={invoice.id}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h5" noWrap>
                                {invoice.title}
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h5" noWrap>
                                {invoice.description}
                            </Typography>
                        </Box>
                        <Divider />
                        <Stack gap={2} py={2}>
                            <AppointmentDetailsRow
                                title="Total"
                                description={`$${numberWithCommas(invoice.total, 2)}`}
                            />
                        </Stack>
                    </Box>
                </Stack>
            </Box>
        );
    }
    return (
        <Box sx={{ my: 2, textAlign: 'right' }}>
            <Button variant="outlined" onClick={createInvoiceHandler}>
                Create Invoice
            </Button>
        </Box>
    );
};
